// App.js
import React from "react";
import { Provider } from "react-redux";
import { ThemeProvider, createTheme } from "@mui/material/styles";
import CssBaseline from "@mui/material/CssBaseline";
import { Container } from "@mui/material";
import { store } from "./redux/store";
import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import Services from "./components/Service";
import TalentServices from "./components/TalentServices";
import EventCategories from "./components/EventCategories";
import ProvenTrackRecord from "./components/ProvenTrackRecord";
// import Transparency from "./components/Transparency"; // REMOVED - now inside TalentServices
import AutoFlyCard from "./components/AutoFlyCard";
import Testimonials from "./components/Testimonials";
import ContactForm from "./components/ContactForm";
import Footer from "./components/Footer";
import HeroTransition, {
  RevealSection,
  AnimatedBackground,
} from "./components/HeroTransition.jsx";
import "./App.css";

const theme = createTheme({
  palette: {
    primary: { main: "#6a11cb", light: "#9d4edd", dark: "#4a0d9a" },
    secondary: { main: "#2575fc", light: "#6a9eff", dark: "#0051cb" },
    error: { main: "#ff5e62" },
    background: { default: "#f9f9f9", paper: "#ffffff" },
  },
  typography: {
    fontFamily: '"Poppins", "Roboto", "Helvetica", "Arial", sans-serif',
    h1: { fontFamily: '"Playfair Display", "Georgia", serif', fontWeight: 700 },
    h2: { fontFamily: '"Playfair Display", "Georgia", serif', fontWeight: 700 },
    h3: { fontFamily: '"Playfair Display", "Georgia", serif', fontWeight: 600 },
    h4: { fontFamily: '"Playfair Display", "Georgia", serif', fontWeight: 600 },
  },
  shape: { borderRadius: 12 },
});

function App() {
  return (
    <Provider store={store}>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <div className="App">
          <Navbar />
          <Hero />

          {/* Animated gradient line between Hero and content */}
          <HeroTransition />

          {/* Transparent wrapper — animations only, your page bg shows through */}
          <AnimatedBackground>
            <Container maxWidth="lg" sx={{ py: { xs: 2, md: 8 } }}>
              <RevealSection
                delay={0}
                style={{ marginBottom: 5, paddingBottom: 0 }}
              >
                <Services />
              </RevealSection>
                <TalentServices /> 
              <RevealSection
                delay={0}
                style={{ marginBottom: 5, paddingBottom: 0 }}
              >
                <EventCategories />
              </RevealSection>

              <RevealSection delay={0}>
                <ProvenTrackRecord />
              </RevealSection>
              <RevealSection delay={0}>
                <AutoFlyCard />
              </RevealSection>

              <RevealSection delay={0}>
                <Testimonials />
              </RevealSection>

              <RevealSection delay={0}>
                <ContactForm />
              </RevealSection>
            </Container>
          </AnimatedBackground>

          <Footer />
        </div>
      </ThemeProvider>
    </Provider>
  );
}

export default App;